// Module
var code = "<a class=\"MeDeepLink\" ng-click=\"MeDeepLink.onClick()\" href=\"{{MeDeepLink.getHelpCenterRoute(MeDeepLink.key)}}\" target=\"_blank\"> <dls-icon-book class=\"MeDeepLink__icon\"></dls-icon-book> {{MeDeepLink.linkText}} </a> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/meDeepLink/meDeepLink.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;